import React from 'react';
import { useSelector } from 'react-redux';
import { SelectStyle } from './style';

export default function SelectCompanyList({ setSelectCompanyList }) {
  const { userInfo } = useSelector((state) => state.userSign);
  return (
    <SelectStyle name="selectCompany" onChange={(e) => setSelectCompanyList(e.target.value)}>
      <option value="">Selecione uma empresa</option>
      {userInfo !== null &&
        userInfo.companies.map((comp, index) => {
          return (
            <option key={index + 1} value={comp.companyId._id}>
              {comp.companyId.name}
            </option>
          );
        })}
    </SelectStyle>
  );
}
